<h2 mat-dialog-title class="dialog_title">
    <span>
        {{ "Overlay audio on" | translate }}: {{ videos && videos.length ? (videos.length + ' ' + ('selected videos' | translate)) : data.file.filename }}
    </span>
    <button class="ml-1" mat-icon-button (click)="close()">
        <mat-icon>close</mat-icon>
    </button>
</h2>
<mat-dialog-content class="mat-typography">
    <div class="container form_wrapper" [appDeviceClass]="'custom-scroll custom-scroll-t'" style="min-width: 40vw;">
        <form [formGroup]="form">
            <mat-form-field appearance="standard" class="full_width_form">
                <mat-label>{{ "Inherit tags from categories" | translate }}</mat-label>
                <mat-select [disableOptionCentering]="true" selectDir [multiple]="true" formControlName="parameter_id">
                    <mat-select-trigger class="multi_users">
                        <ng-container *ngIf="form.get('parameter_id').value && form.get('parameter_id').value.length">
                            <ng-container *ngFor="let id of form.get('parameter_id').value">
                                <span>{{ getParamById(id)?.name }}</span>
                            </ng-container>
                        </ng-container>
                    </mat-select-trigger>
                    <mat-option>
                        <ngx-mat-select-search 
                        placeholderLabel="{{ 'Search' | translate }}" 
                        noEntriesFoundLabel="{{ 'no matching tag category found' | translate }}"
                        [formControl]="paramControl"></ngx-mat-select-search>
                    </mat-option>
                    <ng-container *ngFor="let item of parameters$ | async">
                        <mat-option *ngIf="!!item.id" [value]="item.id">
                            <span>{{ item.name }}</span>
                        </mat-option>
                    </ng-container>
                </mat-select>
            </mat-form-field>
        </form>

        <div class="box_wrp d-f-c" style="height: 40px;">
            <mat-checkbox color="primary" [(ngModel)]="is_remember">{{"Remember selection for this device" | translate}}</mat-checkbox>
        </div>

        <div class="" style="position: relative;">
            <h3 #tooltip="matTooltip"
            matTooltip="{{'Tags that are not present in the input files and therefore cannot be inherited' | translate}}"
            [matTooltipPosition]="'above'">{{"Set tags for outcome files" | translate}}</h3>
            <div class="multi_users_cr_jobs" (click)="tagsContainer.open()" #tooltip="matTooltip"
            matTooltip="{{'Tags that are not present in the input files and therefore cannot be inherited' | translate}}"
            [matTooltipPosition]="'above'">
                <ng-container *ngIf="tags && tags.length">
                    <ng-container *ngFor="let tag of tags; let tInd = index;">
                        <div class="d-f-c has_pad">
                            <div class="text_one_line">{{ getValuesById(tag.parameter_value_id)?.value }}</div>
                            <mat-icon style="margin-left: 3.5px; width: 10px; height: 10px; line-height: 10px; font-size: 10px;" 
                            #tooltip="matTooltip"
                            matTooltip="{{'Primary granted' | translate}}"
                            [matTooltipPosition]="'above'" 
                            (click)="$event.preventDefault(); $event.stopPropagation(); tag.is_primary = 0;" 
                            *ngIf="!!tag?.is_primary">thumb_up</mat-icon>

                            <mat-icon 
                            style="margin-left: 3.5px; width: 10px; height: 10px; line-height: 10px; font-size: 10px;" 
                            #tooltip="matTooltip"
                            matTooltip="{{'Primary not granted' | translate}}"
                            [matTooltipPosition]="'above'" 
                            (click)="$event.preventDefault(); $event.stopPropagation(); tag.is_primary = 1;" 
                            *ngIf="!tag?.is_primary">thumb_up_off_alt</mat-icon>

                            <mat-icon 
                            style="margin-left: 3.5px; width: 10px; height: 10px; line-height: 10px; font-size: 10px;" 
                            #tooltip="matTooltip"
                            matTooltip="{{'Remove tag' | translate}}"
                            [matTooltipPosition]="'above'" 
                            (click)="removeTag(tInd)">close</mat-icon>
                        </div>
                    </ng-container>
                </ng-container>
                <ng-container *ngIf="!(tags && tags.length)">
                    <span class="val cp">{{"Not set" | translate}}</span>
                </ng-container>
            </div>
            <mat-form-field appearance="standard" class="full_width_form hide-form-field" style="position: absolute; top: calc(100% - 40px);">
                <!-- <mat-label>{{ "Tag(s)" | translate }}</mat-label> -->
                <mat-select [disableOptionCentering]="true" selectDir #tagsContainer [multiple]="true" [(ngModel)]="tags" [compareWith]="compareTags">
                    <mat-option>
                        <ngx-mat-select-search 
                        placeholderLabel="{{ 'Search' | translate }}" 
                        noEntriesFoundLabel="{{ 'no matching tag found' | translate }}"
                        [formControl]="allValuesControl"></ngx-mat-select-search>
                    </mat-option>
                    <mat-option *ngFor="let tag of allValues$ | async" [value]="{parameter_value_id: tag.id, is_primary: 1}">
                        <div class="d-f-c" style="justify-content: space-between;">
                            <span>{{ tag.value }}</span>
                            <span>{{ tag?.parameter?.name }}</span>
                        </div>
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </div>

        <div class="block_w8 form_with_pads" style="margin-top: 20px;">
            <div class="label_w8" style="margin: 0;">{{"Overlay settings" | translate}}:</div>

            <div class="box_wrp d-f-c" style="height: 40px;">
                <mat-checkbox color="primary" [(ngModel)]="isLoop" #tooltip="matTooltip"
                matTooltip="{{'Repeat overlaid audio for the duration of the video (so there is no silence)' | translate}}"
                [matTooltipPosition]="'above'">{{"Loop audios" | translate}}</mat-checkbox>
            </div>

            <div class="box_wrp d-f-c" style="height: 40px;">
                <mat-checkbox color="primary" [(ngModel)]="isKeepAudio" #tooltip="matTooltip"
                matTooltip="{{'Audio from video and new audio will be mixed' | translate}}"
                [matTooltipPosition]="'above'">{{"Keep the audio in input video" | translate}}</mat-checkbox>
            </div>

            <div class="box_wrp d-f-c" style="height: 40px;">
                <mat-checkbox color="primary" [(ngModel)]="isRandomAudio" #tooltip="matTooltip"
                matTooltip="{{'Each result will have a different random audio order.' | translate}}"
                [matTooltipPosition]="'above'">{{"Shuffle audio tracks" | translate}}</mat-checkbox>
            </div>

            <h2 class="d-f-c" style="justify-content: space-between;">{{"Videos" | translate}}: <mat-icon class="cp" (click)="isOpenAddSet = !isOpenAddSet" style="color: #686868;">{{isOpenAddSet ? 'expand_less' : 'more_vert'}}</mat-icon></h2>

            <div class="box_wrp d-f-c" style="height: 40px; margin-bottom: 10px;" *ngIf="!!isOpenAddSet">
                <mat-checkbox color="primary" [(ngModel)]="isReverse" #tooltip="matTooltip"
                matTooltip="{{'The width and height of the input video will be swapped' | translate}}"
                [matTooltipPosition]="'above'">{{"Reverse orientation" | translate}}</mat-checkbox>
            </div>

            <div class="over_files">
                <div class="file_over" *ngFor="let item of videos, let i = index;">
                    <div class="img">
                        <img [src]="data?.host + item?.thumbnail + '?company_id=' + data?.company?.id">
                    </div>
                    <div class="name text_one_line">
                        {{item.filename}}
                    </div>
                    <div class="id">ID:{{item.id}}</div>
                    <mat-icon class="remove icon_16" (click)="deleteFile(item, videos, i)">close</mat-icon>
                </div>
            </div>
            
            <h2>{{"Audios" | translate}}:</h2>
            <div class="over_files hor" cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event)">
                <div class="file_over hor" *ngFor="let item of audios; let i = index;" cdkDrag>
                    <div class="name text_one_line">
                        {{item.filename}}
                    </div>
                    <div class="id">ID:{{item.id}}</div>
                    <mat-icon class="remove icon_16" (click)="deleteFile(item, audios, i)">close</mat-icon>
                </div>
            </div>
        </div>

    </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <div class="d-f-c" style="justify-content: space-between; padding-top: 10px;">
        <div class="d-f-c">
            <button mat-raised-button (click)="close()">
                {{ "Close" | translate }}
            </button>

            <button class="ml-1" mat-raised-button cdkFocusInitial color="warn" [matMenuTriggerFor]="addFilesMenu">
                {{ "Add file(s)" | translate }}
            </button>
            <mat-menu #addFilesMenu="matMenu" xPosition="before" class="header_menu">
                <div mat-menu-item (click)="selectFile('audio')">
                    {{ "Audio file(s)" | translate }}
                </div>
                <div mat-menu-item (click)="selectFile('video')">
                    {{ "Video file(s)" | translate }}
                </div>
            </mat-menu>
        </div>

        <button class="ml-1" (click)="multiSubmitForm()" mat-raised-button cdkFocusInitial color="primary" [disabled]="data.file.isOverlayingAudio">
            {{ "Export" | translate }}
        </button>
    </div>
</mat-dialog-actions>
